import React, { useContext } from 'react'
import { AuthContext } from "../contexts/AuthContext";
import { useSelector, useDispatch } from 'react-redux'
import { CImage, CSidebar, CSidebarBrand, CSidebarNav, CSidebarToggler } from '@coreui/react'
import { AppSidebarNav } from './AppSidebarNav'
import SimpleBar from 'simplebar-react'
import Logo from '../assets/logo.png'
import 'simplebar/dist/simplebar.min.css'

// 👇 ahora es una función
import getNavigation from './_nav'

const AppSidebar = () => {
  let { user1 } = useContext(AuthContext);
  const dispatch = useDispatch()
  const unfoldable = useSelector((state) => state.sidebarUnfoldable)
  const sidebarShow = useSelector((state) => state.sidebarShow)

  // 👇 aquí sacas el user
  const user = useSelector((state) => state.auth?.user)

  // 👇 nav dinámico por rol
  const navigation = getNavigation(user)

  return (
    <CSidebar
      position="fixed"
      unfoldable={unfoldable}
      visible={sidebarShow}
      onVisibleChange={(visible) => {
        dispatch({ type: 'set', sidebarShow: visible })
      }}
    >
      <CSidebarBrand className="d-none d-md-flex" to="/">
        {
          user1.id &&
          <>
            <CImage
              style={{ borderRadius: '10px', margin: '10px' }}
              className="sidebar-brand-full"
              src={user1.role === 'master' ? Logo : `https://res.cloudinary.com/activecode/image/upload/f_auto,q_auto/bebbo/logo/logo${user1.id}.jpg?${Date.now()}`}
              height={80}
            />
            <CImage
              style={{ borderRadius: '5px', margin: '10px' }}
              className="sidebar-brand-narrow"
              src={user1.role === 'master' ? Logo : `https://res.cloudinary.com/activecode/image/upload/f_auto,q_auto/bebbo/logo/logo${user1.id}.jpg?${Date.now()}`}
              height={35}
              width={50}
            />
          </>
        }
      </CSidebarBrand>

      <CSidebarNav>
        <SimpleBar>
          <AppSidebarNav items={navigation} />
        </SimpleBar>
      </CSidebarNav>

      <CSidebarToggler
        className="d-none d-lg-flex"
        onClick={() =>
          dispatch({ type: 'set', sidebarUnfoldable: !unfoldable })
        }
      />
    </CSidebar>
  )
}

export default React.memo(AppSidebar)
